<script>
  import { createEventDispatcher } from 'svelte';
  export let active = false;
  export let cpu = 0;
  export let memory = 0;

  const dispatch = createEventDispatcher();
</script>

{#if active}
  <div class="safe-mode-banner" id="safe-mode-banner">
    <div class="banner-content">
      <div class="banner-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
          <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
      </div>
      <div class="banner-text">
        <strong>SAFE MODE ACTIVE</strong>
        <span>Non-critical apps have been disabled to prevent system overload.</span>
      </div>
      <div class="banner-stats">
        <span>CPU: {cpu}%</span>
        <span class="stats-sep">|</span>
        <span>Memory: {memory}%</span>
      </div>
      <button class="deactivate-btn" on:click={() => dispatch('deactivate')} id="deactivate-safe-mode">
        Deactivate Safe Mode
      </button>
    </div>
  </div>
{/if}

<style>
  .safe-mode-banner {
    background: rgba(245, 158, 11, 0.1);
    border: 1px solid rgba(245, 158, 11, 0.3);
    border-radius: var(--radius-md);
    padding: 16px 20px;
    margin-bottom: 24px;
    animation: fadeIn 0.3s ease;
  }

  .banner-content {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
  }

  .banner-icon {
    color: var(--neon-orange);
    animation: pulse 2s infinite;
    flex-shrink: 0;
  }

  .banner-text {
    flex: 1;
    min-width: 200px;
  }

  .banner-text strong {
    display: block;
    color: var(--neon-orange);
    font-size: 14px;
    letter-spacing: 0.04em;
  }

  .banner-text span {
    font-size: 13px;
    color: var(--text-secondary);
  }

  .banner-stats {
    font-size: 13px;
    color: var(--text-secondary);
    display: flex;
    gap: 8px;
  }

  .stats-sep {
    opacity: 0.4;
  }

  .deactivate-btn {
    padding: 8px 18px;
    background: rgba(245, 158, 11, 0.15);
    border: 1px solid rgba(245, 158, 11, 0.4);
    border-radius: var(--radius-sm);
    color: var(--neon-orange);
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
  }

  .deactivate-btn:hover {
    background: rgba(245, 158, 11, 0.25);
    border-color: var(--neon-orange);
  }

  @media (max-width: 768px) {
    .banner-content { flex-direction: column; align-items: flex-start; gap: 10px; }
  }
</style>
